import { faChevronRight, faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, IconButton, Typography } from '@mui/material';
import { useEffect, useRef, useState } from 'react';
import { HomeNotificationCardProps } from '../../interfaces/props/HomeNotificationCardProps';
import './styles.css';
import { sxHomeShowNotification, sxHoverNotificationCardHome, sxTextNotification } from './sxProps';
import { useAccessibility } from '../../Store/contexts/AccessibilityContext';

const HomeNotificationCard: React.FC<HomeNotificationCardProps> = ({ icon, text, idComunic, onClick }) => {

    const [isVisible, setIsVisible] = useState(true);
    const [isButtonCloseNotificationsFocused, setIsButtonCloseNotificationsFocused] = useState(false);
    const buttonRef = useRef<HTMLButtonElement>(null);

    const { fontSizeStyleAccessibility, calculateFontStyle } = useAccessibility();

    useEffect(() => {
        if (isButtonCloseNotificationsFocused) {
            buttonRef.current?.focus();
        } else {
            buttonRef.current?.blur();
        }
    }, [isButtonCloseNotificationsFocused]);

    const handleFocus = () => {
        setIsButtonCloseNotificationsFocused(true);
    };

    const handleBlur = () => {
        setIsButtonCloseNotificationsFocused(false);
    };

    const handleCloseNotificationButton = (e: React.MouseEvent<HTMLButtonElement> | React.KeyboardEvent<HTMLButtonElement>) => {
        e.stopPropagation();
        let event = e.nativeEvent;
        if (event instanceof KeyboardEvent && (event.key === "Enter" || event.key === " ")) {
            setIsVisible(false);
        } else if (event instanceof MouseEvent) {
            setIsVisible(false);
        }
    };

    const handleOpenNotification = (e: React.MouseEvent<HTMLDivElement> | React.KeyboardEvent<HTMLDivElement>) => {
        let event = e.nativeEvent;
        if (event instanceof KeyboardEvent && (event.key === "Enter" || event.key === " ")) {
            onClick()
        } else if (event instanceof MouseEvent) {
            onClick()
        }
    }

    return (
        isVisible && (
            <Box
                className='notification-card-home'
                sx={sxHoverNotificationCardHome}
                tabIndex={0} onKeyDown={handleOpenNotification}
                onClick={handleOpenNotification}
            >
                <div className='home-notification-details-label'>
                    <FontAwesomeIcon className='notification-icon-color-home' icon={icon} size="2xl" />
                    <Typography
                        sx={sxTextNotification}
                        variant="body2" style={{
                            ...fontSizeStyleAccessibility,
                            ...calculateFontStyle(16)
                        }}
                    >
                        {text}
                    </Typography>
                </div>
                <div className='home-show-notification-label'>
                    <button tabIndex={0} aria-label='Ver notificação' style={{background: 'none', border: 'none'}}>
                        <Typography
                            style={fontSizeStyleAccessibility}
                            sx={sxHomeShowNotification}
                                >
                                Ver notificação
                                <FontAwesomeIcon icon={faChevronRight} size="1x" style={{ marginLeft: '6px' }} />
                        </Typography>
                    </button>
                    <div className='home-close-notifications-button' >
                        <IconButton 
                            ref={buttonRef}
                            aria-label="Dispensar notificação"
                            onFocus={handleFocus}
                            onBlur={handleBlur}
                            onClick={handleCloseNotificationButton}
                            onKeyDown={handleCloseNotificationButton}
                        >
                            <FontAwesomeIcon icon={faTimes} size="1x" color='#383838' />
                        </IconButton>
                    </div>
                </div>
            </Box>
        )
    )
}


export default HomeNotificationCard; 